export default "__VITE_ASSET__67348df4__"